export enum InvitationState {
  Sent = 'SENT',
  Viewed = 'VIEWED',
  PartiallyFilled = 'PARTIALLY_FILLED',
  WaitingForApproval = 'WAITING_FOR_APPROVAL',
  Approved = 'APPROVED',
  Archived = 'ARCHIVED',
}
